import { Outlet } from "react-router-dom";
import Header from "../../components/Header/_header";
import Footer from "../../components/Footer/_footer";
import CallBlock from "../../components/CallBlock/CallBlock";

const Layout = () => {
  return (
    <div className="wrapper no-select">
      <Header />
      <div className="page">
        <Outlet />
        <CallBlock />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
